import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  onError?: (error: Error, info: ErrorInfo) => void;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info);
    this.props.onError?.(error, info);
  }

  render() {
    if (this.state.error) {
      return (
        this.props.fallback ?? (
          <div className="p-4 rounded-lg border border-error/30 bg-error/5 text-sm text-error">
            Something went wrong rendering this section.
            <div className="mt-1 text-xs opacity-70 font-mono break-all">
              {this.state.error.message}
            </div>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
